import { render, staticRenderFns } from "./ClienteSettings.vue?vue&type=template&id=935b5aae"
import script from "./ClienteSettings.vue?vue&type=script&lang=js"
export * from "./ClienteSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports